import * as React from "react";
import type { SVGProps } from "react";
export const SvgArrowPointRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 14 14" {...props}>
    <path fill="currentColor" d="m9.433 6.417-3.129-3.13.825-.824L11.667 7l-4.538 4.537-.825-.825 3.13-3.129h-7.1V6.417h7.1Z" />
  </svg>
);
